import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import AWS from 'aws-sdk';
//import dynamodb from './aws-dynamoDbRead.js';
import './maindefinitions.css';
import './GrowerGallery.css';

class GrowerGallery extends Component {

	constructor(props) {
    super(props);
		this.state = {
			// queryData: '',
      farmTable: ''
		};


  //    this.handleChange = this.handleChange.bind(this);
  //    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
	  this.props.auth.currentCredentials()
      .then(credentials => {
				console.log('credentials');
				console.log(credentials);
        const dynamodb = new AWS.DynamoDB.DocumentClient({
          region: 'us-east-1',
          credentials: this.props.auth.essentialCredentials(credentials)
        });

        var params = {
            ExpressionAttributeValues: {
                ':statusGrowerPage': 'published',
            },
            ExpressionAttributeNames: {
                '#statusGrowerPage': 'statusGrowerPage',
            },
            FilterExpression: '#statusGrowerPage = :statusGrowerPage',
            TableName: 'Farms'
        };

        dynamodb.scan(params, (err, data) => {
          if (err) {
						console.log('DynamoDB scan error');
            console.log(err);
            return null;
          } else {
            this.setState({
              farmTable: data.Items
            });
          }
        });
      })
			.catch((e) => {
				console.log('Credentials Error in Grower gallery');
				console.log(e);
			})

  }

  // componentWillUnmount() {
  //   var unsubscribe = this.props.dbRef.onSnapshot(() => {});
  //   unsubscribe();
  // }



  render() {
    var galleryItems;
		if (this.state.farmTable) {
			galleryItems = this.state.farmTable.map((doc, index) => {
				return (
					<div key={doc.farmId} className="responsive">
						<div className="gallery">
							<Link to={'/growers/' + doc.farmId}>
								<img src={doc.farmPicture} alt="Farm View" width="500" height="500" />
							</Link>
							<div className="descgallery detailtext">
									<h2 className="pagetitle2"> {doc.farmName}</h2>
	  								 {doc.growerName}
	  						</div>
						</div>
					</div>

				);
			});
		} else {
			galleryItems = '';
		}

    return (
			<div className="backgroundWhite">
				<div className="texts">

					<p className="pagetitle">Meet the growers</p>

				</div>

			  <div className="growersgallery">

				{galleryItems}

			    <div className="clearfix"></div>

			  </div>
			</div>


    );
  }
}

export default GrowerGallery;
